import MyClientsModule from './containers/myClientsModule'

export {default as MyClientsModuleLayout} from './components/myClientsModuleLayout'

export default MyClientsModule
